var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import cx from 'clsx';
import { InputLabel } from '../input_label/InputLabel';
import { checkStyles, customCheckboxVariants, focusRingStyles, inputStyles, wrapperStyles, } from './Checkbox.css';
export const Check = ({ className }) => (_jsx("svg", { "aria-hidden": "true", className: className, viewBox: "0 0 138 96", xmlns: "http://www.w3.org/2000/svg", children: _jsx("path", { d: "M132.15 6.09l-84 84-42.01-42", fill: "none", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "12" }) }));
const CheckboxComponent = React.forwardRef(function Checkbox(_a, ref) {
    var { checked, className, hasError, id, name, onChange, value } = _a, rest = __rest(_a, ["checked", "className", "hasError", "id", "name", "onChange", "value"]);
    return (_jsxs("div", { className: cx(wrapperStyles, className), children: [_jsx("input", Object.assign({ checked: checked, className: inputStyles, id: id, name: name, onChange: onChange, type: "checkbox", value: value }, rest, { ref: ref })), _jsx("div", { className: focusRingStyles }), _jsx("div", { className: customCheckboxVariants[hasError ? 'hasError' : 'default'], children: _jsx(Check, { className: checkStyles }) })] }));
});
export const Checkbox = CheckboxComponent;
Checkbox.Label = InputLabel;
